<template>
  <div class="flex">
      <DutyCellWithDetailView showTitle :column="{columnName:'z9Duty'}" :absence="absence" :is-assigned-to-different-view="isAssignedToDifferentView"></DutyCellWithDetailView>
      Linie/Kurs {{lineTrack}}
    <FromTo :isDisabled="isDisabled" :asChip="false" :column="column" :absence="absence"></FromTo>

  </div>
</template>
<script>
import FromTo from './FromTo.vue';
import DutyCellWithDetailView
  from "@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/absenceTableCells/DutyCellWithDetailView.vue";

export default {
  name: 'DutyLineTrack',
  components: {
    DutyCellWithDetailView,
    FromTo,
  },
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
    isDisabled:{type:Boolean,default:false}
  },
  computed: {
    duty() {
      if (this.column.columnName==='z9FromToTwoLines') {
        return this.absence.z9Duty?this.absence.z9Duty:''
      }
      if (this.column.columnName==='dutyLineTrack'){
        return this.absence.duty?this.absence.duty:''
      }
      return '';
    },
    lineTrack() {
      if (this.column.columnName==='z9FromToTwoLines'){
        return this.absence.z9Line?this.absence.z9Line:''
      }
      return this.absence.line?this.absence.line:''
    }
  },
};
</script>